<template>
    <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
        <h1>{{$t("operaciones.grid.operaciones")}}</h1>
        <operaciones-grid/>
    </div>
</template>

<script setup lang="ts">
import OperacionesGrid from "@/components/operaciones-energia/OperacionesEnergiaGrid.vue";
import { useComunicadosPortalSinLeer } from "@/composables/useComunicadosPortalSinLeer";

useComunicadosPortalSinLeer();
</script>
